'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPlay, iconPlayTag } from '@ni/nimble-components/dist/esm/icons/play';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPlay };
export { iconPlayTag };
export const NimbleIconPlay = wrap(IconPlay);